import { staticButtons } from "../Constants/Mock";
import { normalizePaymentMethodsData } from "./Normalizers";
import useCallAxios from "./useCallAxios";

const filterQuery = (values) => ({ ...values });

export const usePaymentMethodsData = () => {
  const context = `payment_methods`;
  const { reset, requestSuccess, requestData, requestLoading, fetchGET } =
    useCallAxios({
      context,
    });

  const handleGET = (params) => {
    fetchGET({ context, queryParameters: filterQuery(params) });
  };

  //const state = normalizePaymentMethodsData(requestData);
  const state = normalizePaymentMethodsData({
    data: { itens: staticButtons },
  });
  return {
    reset,
    loading: requestLoading,
    state,
    success: requestSuccess,
    handleGET,
  };
};
